
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as JourneysIconComponent } from "./journeys-icon.svg";

export const JourneysIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <JourneysIconComponent {...props} />;
};
